<template>
    <div>
        <ul v-if="props.documents.length" role="list" class="divide-y divide-gray-200 !pl-0">
            <li
                v-for="document in props.documents"
                :key="document.id"
                class="flex items-center justify-between gap-x-6 py-3">
                <div class="flex min-w-0 gap-x-4">
                    <div class="flex items-center">
                        <div
                            class="flex h-12 w-12 flex-wrap items-center justify-center rounded-full border border-gray-300 bg-gray-50 text-gray-600">
                            <DocumentTextIcon class="h-7 w-7"></DocumentTextIcon>
                        </div>
                    </div>
                    <div class="min-w-0 flex-auto">
                        <p class="truncate text-sm font-semibold leading-6 text-gray-900" :title="document.name">
                            {{ document.name }}
                        </p>
                        <p class="mt-1 truncate text-xs leading-5 text-gray-500" :title="document.description">
                            {{ document.description }}
                        </p>
                    </div>
                </div>
                <BaseButtonMuted
                    size="sm"
                    class="font-semibold"
                    :href="document.url"
                    target="_blank"
                    @click="sendDownloadEvent(document)">
                    Download
                </BaseButtonMuted>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { ContractDocument } from '../../../utilities/investment-process/useCampaign'
import { DocumentTextIcon } from '@heroicons/vue/solid'
import BaseButtonMuted from '../../../components/base/BaseButtonMuted.vue'
import useEventStore from '../../../utilities/useEvent'

const props = defineProps<{
    documents: ContractDocument[]
}>()

const eventStore = useEventStore()

const sendDownloadEvent = (document: ContractDocument) => {
    eventStore.trackEvent({
        event: 'open_document',
        data: {
            document_id: document.id,
            document_name: document.name,
            document_link: document.url,
            document_type: 'Contract Data Document',
        },
    })
}
</script>
